import { Button, LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import Grid from '../../components/Grid/Grid';
import Loader from '../../components/Loader/Loader';
import { LoadingSpinnerWithContent } from '../../components/LoadingSpinnerWithContent/LoadingSpinnerWithContent';
import { useBackBlocker } from '../../hooks/use-back-blocker';
import { useStore } from '../../hooks/use-store';
import './OfferSetup.scss';

const OfferSetup = observer(() => {
  const navigate = useNavigate();
  const { offerSetupStore: store, globalModalStore } = useStore();
  const { loaders, colDefs, filteredPracticeOffers, hasUnsavedChanges } = store;

  useEffect(() => {
    void store.init();
  }, [store]);

  useBackBlocker(
    useCallback(
      allowBack => {
        if (hasUnsavedChanges) {
          globalModalStore.showLeavePagePopup(() => allowBack());
        } else {
          allowBack();
        }
      },
      [globalModalStore, hasUnsavedChanges],
    ),
  );

  return (
    <div className='offer-setup_wrapper'>
      <div className='spot-typography__heading--level-2'>Setup your Trupanion Exam Day Offer</div>
      <div className='spot-typography__text--tertiary'>
        Select which Cornerstone window(s) to enable the Offer feature.
      </div>
      {loaders.page ? (
        <LoadingSpinner size='large' />
      ) : (
        <>
          <Button
            className='refresh-practices-btn'
            iconLeft='refresh-redo'
            variant='link'
            size='small'
            disabled={loaders.retrieve}
            onClick={() => void store.retrievePractices()}
            data-testid='refresh-practices-btn'
          >
            Refresh Practices
          </Button>
          {loaders.retrieve && (
            <LoadingSpinnerWithContent size='large'>
              One moment while we retrieve your practices from your local Cornerstone Server.
            </LoadingSpinnerWithContent>
          )}
          {!loaders.retrieve && (
            <Grid id='practices-grid' columns={colDefs} data={filteredPracticeOffers} />
          )}
          <div className='page-bottom-actions'>
            <Button
              variant='link'
              size='small'
              className='back'
              onClick={() => void navigate(-1)}
              data-testid='back-btn'
            >
              Back
            </Button>
            <div>
              <Button
                variant='secondary'
                size='small'
                data-testid='dashboard-btn'
                onClick={() => void navigate('/')}
              >
                Dashboard
              </Button>
              <Button
                variant='primary'
                size='small'
                disabled={loaders.save}
                data-testid='species-breeds-btn'
                onClick={() => void store.saveOffersAndNavigateToSpeciesBreeds()}
              >
                <Loader loading={loaders.save}>Manage Species/Breeds</Loader>
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
});

export default OfferSetup;
